import { render, staticRenderFns } from "./EditBetModal.vue?vue&type=template&id=53a25586&"
import script from "./EditBetModal.vue?vue&type=script&lang=js&"
export * from "./EditBetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports